import React from "react";
import styled from "@emotion/styled";

const Footer = () => <TurfFooter>Footer</TurfFooter>;

const TurfFooter = styled.div`
  background: #f2c24e;
  color: white;
`;

export default Footer;
